/**
 * Defines a set of custom colors.
 */
export enum Colors {
  white = '#ffffff',
  black = '#16171B',
  red = '#EE1F27',

  red100 = '#fef6f1',
  red200 = '#fde3da',
  red300 = '#fba18e',
  red400 = '#f77d71',
  red500 = '#EE1F27',
  red600 = '#d0313f',
  red700 = '#ae223a',
  red800 = '#8c1534',
  red900 = '#740d30',

  gray50 = '#F9F9FB',
  gray100 = '#f3f4f6',
  gray200 = '#eceff4',
  gray300 = '#dbe0e7',
  gray400 = '#b8c0cd',
  gray500 = '#959DAC',
  gray600 = '#6C7993',
  gray700 = '#4b587b',
  gray800 = '#2f3c63',
  gray900 = '#1c2752',

  blue50 = '#F1F7FF',
  blue100 = '#EAF3FF',
  blue200 = '#D4E5FF',
  blue300 = '#61A1FF',
  blue400 = '#3787FF',
  blue500 = '#1A5FEA',
  blue600 = '#0049B5',
  blue700 = '#003688',
  blue800 = '#002761',
  blue900 = '#001C43',

  yellow100 = '#FEFAE5',
  yellow200 = '#FEF2B9',
  yellow300 = '#FEE06F',
  yellow400 = '#fdd34b',
  yellow500 = '#FFC24A',
  yellow600 = '#d99d0b',
  yellow700 = '#b67e08',
  yellow800 = '#926105',
  yellow900 = '#794c03',

  orange100 = '#fef6e5',
  orange200 = '#fee1b4',
  orange300 = '#febb67',
  orange400 = '#fda041',
  orange500 = '#fc7303',
  orange600 = '#d85602',
  orange700 = '#b53e01',
  orange800 = '#922a00',
  orange900 = '#781c00',

  pink100 = '#FFF2F8',
  pink200 = '#FFE7F1',
  pink300 = '#FFA7CD',
  pink400 = '#FF88BB',
  pink500 = '#FE559E',
  pink600 = '#E23982',
  pink700 = '#C92069',
  pink800 = '#B30A53',
  pink900 = '#970041',

  violet100 = '#FAF3FF',
  violet200 = '#F6EBFF',
  violet300 = '#DCB0FF',
  violet400 = '#CF94FF',
  violet500 = '#BB65FF',
  violet600 = '#A344EF',
  violet700 = '#8B2CD7',
  violet800 = '#7415C0',
  violet900 = '#6405B0',

  purple100 = '#FEF1FF',
  purple200 = '#FDEAFF',
  purple300 = '#F6A3FF',
  purple400 = '#F282FF',
  purple500 = '#E551F6',
  purple600 = '#C935DA',
  purple700 = '#B01CC1',
  purple800 = '#9A06AB',
  purple900 = '#7C008B',

  turquoise100 = '#E5FFFA',
  turquoise200 = '#ADFFEF',
  turquoise300 = '#C6F8EE',
  turquoise400 = '#52DFC4',
  turquoise500 = '#30BDA2',
  turquoise600 = '#14A186',
  turquoise700 = '#00866C',
  turquoise800 = '#006552',
  turquoise900 = '#004D3F',

  green100 = '#f2fced',
  green200 = '#e2f9d9',
  green300 = '#abef9b',
  green400 = '#87e07d',
  green500 = '#36B37E',
  green600 = '#3daf45',
  green700 = '#2a923a',
  green800 = '#1a7630',
  green900 = '#10612a',

  hover = '#003688',
}
